import axios from 'axios';
const service = axios.create({
    // timeout: 3000,
    baseURL: "https://www.jnccljh.com/api/"
})
// axios.defaults.headers['Content-Type'] = 'multipart/form-data'
service.interceptors.request.use(config => {
    var token = localStorage.getItem('token')
    if (token) {
        config.headers['token'] =  token
    }
    return config
}, err => {
    return err
})

service.interceptors.response.use(response => {
    return response
}, err => {
    console.log('响应失败')
})
export default service


// WEBPACK FOOTER //
// ./src/utils/request.js